<template>
  <a-layout class="app-main-shell-layout">
    <app-side-nav
      v-if="hasSidenav"
      :collapsed="collapsed"
      :gotPermissions="gotPermissions"
      :openKeys="openKeys"
      :selectedKeys="selectedKeys"
      :sidenavMenu="sidenavMenu"
      :loggedinUserPermissions="loggedinUserPermissions"
      @open-change="$emit('open-change', $event)"
      @goto="$emit('goto', $event)"
      @goto-submenu="$emit('goto-submenu', $event)"
    />
    <a-layout :class="mainSectionClass">
      <a-layout-content class="app-main-shell-content">
        <div id="subapp-viewport"></div>
      </a-layout-content>
    </a-layout>
  </a-layout>
</template>

<script>
import { defineComponent } from 'vue'
import AppSideNav from './AppSideNav.vue'

export default defineComponent({
  name: 'AppMainShell',
  components: {
    AppSideNav,
  },
  props: {
    showSidenav: {
      type: String,
      default: 'no',
    },
    collapsed: {
      type: Boolean,
      default: false,
    },
    gotPermissions: {
      type: Boolean,
      default: false,
    },
    openKeys: {
      type: Array,
      default: () => [],
    },
    selectedKeys: {
      type: Array,
      default: () => [],
    },
    sidenavMenu: {
      type: Array,
      default: () => [],
    },
    loggedinUserPermissions: {
      type: Array,
      default: () => [],
    },
  },
  computed: {
    hasSidenav() {
      return this.showSidenav === 'yes'
    },
    mainSectionClass() {
      return {
        'main-section': true,
        'm-l': !this.hasSidenav,
      }
    },
  },
  emits: ['open-change', 'goto', 'goto-submenu'],
})
</script>

<style scoped>
.app-main-shell-layout {
  min-height: 100vh;
  padding-top: 48px;
}

.app-main-shell-content {
  min-height: 280px;
}
</style>
